import React from 'react';
import languages from '../../Services/Helpers/languages';



export default function Header({handleLanguageChange, lang, restaurant}) {
    let options = languages.map(language => {
        return <option defaultValue={language} value={ language} key={language}>{language.toUpperCase()}</option>
      });

    return (
        <header className="form__header">
            <div className="header__intro">
                <div className="intro__title">
                    {(restaurant) && <h1>{restaurant.name}</h1>}
                    <div className="title__language">
                        <select className="selectlanguage" onChange={(e) => handleLanguageChange(e)}>
                            {options}
                        </select>
                    </div>
                </div>
            </div>
        </header >
    )
}